
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream/create/multiple",
      function () {
        return require("private-next-pages/stream/create/multiple.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream/create/multiple"])
      });
    }
  